var _rect, _defs, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternRandomized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#EFF2FB",
    width: 2000,
    height: 1500
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "#EFF2FB",
    strokeWidth: 0.5,
    width: 1,
    height: 1,
    id: "s"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    width: 3,
    height: 3,
    patternUnits: "userSpaceOnUse",
    patternTransform: "scale(50) translate(-980 -735)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#edf0f8",
    href: "#s",
    y: 2
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#edf0f8",
    href: "#s",
    x: 1,
    y: 2
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#eaedf6",
    href: "#s",
    x: 2,
    y: 2
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#eaedf6",
    href: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#e8ebf3",
    href: "#s",
    x: 2
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#e8ebf3",
    href: "#s",
    x: 1,
    y: 1
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    width: 7,
    height: 11,
    patternUnits: "userSpaceOnUse",
    patternTransform: "scale(50) translate(-980 -735)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e5e8f1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    y: 5
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 1,
    y: 10
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 2,
    y: 1
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 2,
    y: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 3,
    y: 8
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4,
    y: 3
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4,
    y: 7
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 5,
    y: 2
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 5,
    y: 6
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 6,
    y: 9
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    width: 5,
    height: 13,
    patternUnits: "userSpaceOnUse",
    patternTransform: "scale(50) translate(-980 -735)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e5e8f1"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    y: 5
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    y: 8
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 1,
    y: 1
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 1,
    y: 9
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 1,
    y: 12
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 2
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 2,
    y: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 3,
    y: 2
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 3,
    y: 6
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 3,
    y: 11
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4,
    y: 3
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4,
    y: 7
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 4,
    y: 10
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    width: 17,
    height: 13,
    patternUnits: "userSpaceOnUse",
    patternTransform: "scale(50) translate(-980 -735)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e3e6ee"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    y: 11
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 2,
    y: 9
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 5,
    y: 12
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 9,
    y: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 12,
    y: 1
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 16,
    y: 6
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "d",
    width: 19,
    height: 17,
    patternUnits: "userSpaceOnUse",
    patternTransform: "scale(50) translate(-980 -735)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#EFF2FB"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    y: 9
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 16,
    y: 5
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 14,
    y: 2
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 11,
    y: 11
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 6,
    y: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#e0e3eb"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 3,
    y: 13
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 9,
    y: 7
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 13,
    y: 10
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 15,
    y: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 18,
    y: 1
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "e",
    width: 47,
    height: 53,
    patternUnits: "userSpaceOnUse",
    patternTransform: "scale(50) translate(-980 -735)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1A73E9"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 2,
    y: 5
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 16,
    y: 38
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 46,
    y: 42
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 29,
    y: 20
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "f",
    width: 59,
    height: 71,
    patternUnits: "userSpaceOnUse",
    patternTransform: "scale(50) translate(-980 -735)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1A73E9"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 33,
    y: 13
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 27,
    y: 54
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 55,
    y: 55
  }))), /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 139,
    height: 97,
    patternUnits: "userSpaceOnUse",
    patternTransform: "scale(50) translate(-980 -735)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1A73E9"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 11,
    y: 8
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 51,
    y: 13
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 17,
    y: 73
  }), /*#__PURE__*/React.createElement("use", {
    href: "#s",
    x: 99,
    y: 57
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    width: "100%",
    height: "100%"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#b)",
    width: "100%",
    height: "100%"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#h)",
    width: "100%",
    height: "100%"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#c)",
    width: "100%",
    height: "100%"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#d)",
    width: "100%",
    height: "100%"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#e)",
    width: "100%",
    height: "100%"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#f)",
    width: "100%",
    height: "100%"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#g)",
    width: "100%",
    height: "100%"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternRandomized);
export default __webpack_public_path__ + "static/media/pattern-randomized.c8bc7839b4526b37d6ae7aa6604a7caf.svg";
export { ForwardRef as ReactComponent };